import React from 'react';
import { Link } from 'react-router-dom';
import './CourtOfProtection.css';

const PROCESS_STEPS = [
  {
    num: '1',
    title: 'Preparing the application',
    desc: 'Completion of the relevant Court of Protection forms, including details about the individual and the decisions required.',
  },
  {
    num: '2',
    title: 'Medical assessment',
    desc: 'A formal assessment of capacity is obtained from a qualified professional.',
  },
  {
    num: '3',
    title: 'Submission to the Court',
    desc: 'The application is filed with the Court of Protection along with the required fee.',
  },
  {
    num: '4',
    title: 'Notification of interested parties',
    desc: 'Family members and other relevant individuals are formally notified of the application.',
  },
  {
    num: '5',
    title: 'Court review',
    desc: 'The Court considers the application and may request further information or list the matter for a hearing.',
  },
  {
    num: '6',
    title: 'Court decision',
    desc: 'An order is made, which may include appointing a Deputy or approving a specific decision.',
  },
];

const HELP_LIST = [
  'Advising on the appropriate type of application',
  'Preparing and submitting all documentation',
  'Liaising with medical professionals',
  'Managing notification requirements',
  'Supporting you until the Court\'s decision is received',
];

const CourtOfProtection = () => {
  return (
    <div className="cop-page">
      {/* Hero */}
      <section className="cop-hero">
        <div className="cop-hero__inner">
          <nav className="cop-hero__breadcrumb">
            <Link to="/">Home</Link>
            <span className="cop-hero__breadcrumb-sep">/</span>
            <span className="cop-hero__breadcrumb-current">Court of Protection</span>
          </nav>
          <h1 className="cop-hero__title">Court of Protection Applications</h1>
        </div>
      </section>

      {/* Intro */}
      <section className="cop-section cop-section--white">
        <div className="cop-section__inner">
          <p className="cop-text">
            At The LPA Company, we guide clients through the Court of Protection process with
            clarity and care, ensuring that decisions are made in the best interests of those
            who lack mental capacity.
          </p>
        </div>
      </section>

      {/* What is COP */}
      <section className="cop-section cop-section--alt">
        <div className="cop-section__inner">
          <h2 className="cop-section__title">What is the Court of Protection?</h2>
          <p className="cop-text">
            The Court of Protection makes decisions for individuals who are unable to make
            decisions for themselves due to a lack of mental capacity. This may include matters
            relating to property and finances, health, or personal welfare.
          </p>
        </div>
      </section>

      {/* When needed */}
      <section className="cop-section cop-section--white">
        <div className="cop-section__inner">
          <h2 className="cop-section__title">When is an application needed?</h2>
          <p className="cop-text" style={{ marginBottom: 20 }}>An application may be required where:</p>
          <ul className="cop-list">
            <li>No Lasting Power of Attorney is in place</li>
            <li>Decisions need to be made about finances, property, or care</li>
            <li>Ongoing authority is required to manage someone's affairs (Deputyship)</li>
          </ul>
        </div>
      </section>

      {/* Process */}
      <section className="cop-section cop-section--alt">
        <div className="cop-section__inner">
          <h2 className="cop-section__title">The application process</h2>
          <p className="cop-text" style={{ marginBottom: 32 }}>The process typically involves:</p>
          <div className="cop-steps">
            {PROCESS_STEPS.map((step) => (
              <div key={step.num} className="cop-step">
                <span className="cop-step__num">{step.num}</span>
                <div className="cop-step__content">
                  <h3 className="cop-step__title">{step.title}</h3>
                  <p className="cop-step__desc">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How we help */}
      <section className="cop-section cop-section--white">
        <div className="cop-section__inner">
          <h2 className="cop-section__title">How we can help</h2>
          <p className="cop-text" style={{ marginBottom: 20 }}>
            We provide full support throughout the process, including:
          </p>
          <ul className="cop-list">
            {HELP_LIST.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
          <p className="cop-text" style={{ marginTop: 24 }}>
            Our aim is to make what can be a complex and sensitive process as straightforward
            and stress-free as possible.
          </p>
        </div>
      </section>

      {/* CTA */}
      <section className="cop-cta">
        <div className="cop-cta__inner">
          <h2 className="cop-cta__title">Get in Touch</h2>
          <p className="cop-cta__desc">
            For more information or to discuss your circumstances, please contact us.
          </p>
          <Link to="/contact" className="btn btn-primary">
            Contact Us
          </Link>
        </div>
      </section>
    </div>
  );
};

export default CourtOfProtection;
